import { useEffect, useRef } from 'react';

/**
 * A React hook that returns a mutable ref object that always contains the latest value.
 * Useful to avoid stale closures in callbacks or effects.
 *
 * @see https://www.reactuse.com/state/uselatest/
 */
export function useLatest<Value>(value: Value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
